import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { COST_BAR_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const CostChart = () => {
    const originalDataCompany = [150,165];
    const staticDataCompany = [61];
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData,paidMediaCostData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, costBarChart } = dtcData;
    const { categories,dataSets } = paidMediaCostData;
    const updatedCategories = customCategories(staticDataCompany.includes(company.id) ? ['2025-01','2025-02','2025-03'] :categories);
    const finalData = (originalDataCompany.includes(company.id) ? dataSets : [{
        name: 'Display',
        data: [7.83,6.17,7.13]
    },
    {
        name: 'Native',
        data: [13.85,11.59,12.63]
    }
    ]);
    const barChartOptions = useMemo(() => ({
        ...COST_BAR_CHART_OPTIONS,
        xaxis: {
            ...COST_BAR_CHART_OPTIONS.xaxis,
            categories: updatedCategories
        },
        plotOptions: {
            ...COST_BAR_CHART_OPTIONS.plotOptions,
            bar: {
                ...COST_BAR_CHART_OPTIONS.plotOptions.bar,
                columnWidth: updatedCategories.length > 10 ? '40%' : '50px'
            }
        }
    }), [categories]);

    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                   Cost Per Click
                </Typography>
                {/* <Typography className="text-sm-regular gray-500" sx={{ marginTop: '4px' }}>
                    * Total Digital Cost Spent on a monthly basis
                </Typography> */}
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isWebMatrixPatientLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={finalData}
                        height={'400px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CostChart;
